import React, { useState, useEffect } from 'react';
import './Clock.css';

const FullscreenClock = ({ onExit }) => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);


    // Handle escape key
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onExit();
      }
    };

    // Handle fullscreen change (when user exits fullscreen via browser controls)
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        onExit();
      }
    };

    document.addEventListener('keydown', handleEscape);
    document.addEventListener('fullscreenchange', handleFullscreenChange);

    return () => {
      clearInterval(timer);
      document.removeEventListener('keydown', handleEscape);
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, [onExit]);

  const formatTime = (date) => {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return (
      <>
        {hours}
        <span className="clock-colon">:</span>
        {minutes}
        <span className="clock-colon">:</span>
        {seconds}
      </>
    );
  };

  return (
    <div className="clock-fullscreen" onClick={onExit}>
      <div className="clock-logo">
        <img src="/images/onetimer-logo.svg" alt="OneTimer" />
      </div>
      <div className="clock-display">
        {formatTime(time)}
      </div>
    </div>
  );
};

export default FullscreenClock;